export class CancelExclusionFromBackupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isExclusionCanceled",
            "baseName": "isExclusionCanceled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CancelExclusionFromBackupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
